module.exports = __webpack_public_path__ + "img/defence-24.85b6f17e.svg";